// Plain-English labels — clients/staff should never see internal words like
// "parsed" or "needs_manual". Anything not in the map falls back to a humanized
// version of the raw status.
const FRIENDLY_LABELS: Record<string, string> = {
  parsed: "Uploaded",
  needs_manual: "Needs review",
  failed: "Upload failed",
  pending: "Uploading…",
  importing: "Uploading…",
};

export function StatusPill({ status }: { status: string }) {
  const normalized = status.toLowerCase().replace(/[\s_]+/g, "-");
  const humanLabel = FRIENDLY_LABELS[status.toLowerCase()] ?? status.replace(/_/g, " ");
  return (
    <span
      className={`status-pill ${normalized}`}
      role="status"
      aria-label={`Status: ${humanLabel}`}
    >
      {humanLabel}
    </span>
  );
}
